export const recommendationSpaceStyle = {
    width: "100%",
    padding: "24px",
    backgroundColor: "white"
};

export const recommendationSliderStyle = {
    width: "99%"
}